module.exports = __webpack_public_path__ + "img/img_sub_ser_Integration03.d8d18aa7.svg";